import React, { useState, useEffect } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton } from "@mui/material";
import FileLink from "../../../../CBComponents/CBFileLink/FileLink";

const ImageSlider = ({ attachments, canEdit, handleDeleteFile, entityType, dir }) => {
	const [currentIndex, setCurrentIndex] = useState(0);

	useEffect(() => {
		if (!attachments || attachments.length === 0) {
			setCurrentIndex(0);
			return;
		}
		
		if (currentIndex >= attachments.length) {
			setCurrentIndex(Math.max(0, attachments.length - 1));
		}
	}, [attachments, currentIndex]);

	if (!attachments || attachments.length === 0) return null;
    const currentAttachment = attachments[currentIndex];

	const handlePrevious = () => {
		setCurrentIndex((prevIndex) => (prevIndex === 0 ? attachments.length - 1 : prevIndex - 1));
	};

	const handleNext = () => {
		setCurrentIndex((prevIndex) => (prevIndex === attachments.length - 1 ? 0 : prevIndex + 1));
	};

	// Check if the current index is out of bounds and adjust it accordingly
	if (currentIndex < 0 || currentIndex >= attachments.length) {
		setCurrentIndex(attachments.length - 1);
	}

	const indicatorsPerPage = 15; // Number of indicators to show per page

	// Calculate the start and end index of the indicators to display based on the current page
	const startIndex = Math.floor(currentIndex / indicatorsPerPage) * indicatorsPerPage;
	const endIndex = Math.min(startIndex + indicatorsPerPage, attachments.length);

	// Generate the slider indicators based on the current page
	const sliderIndicators = attachments.slice(startIndex, endIndex).map((_, index) => {
		const indicatorIndex = startIndex + index;
		return (
			<div
				key={indicatorIndex}
				style={{
					width: "8px",
					height: "8px",
					borderRadius: "50%",
					backgroundColor: indicatorIndex === currentIndex ? "#FFFFFF" : "#616263",
					margin: "0 4px",
					cursor: "pointer"
				}}
				onClick={() => setCurrentIndex(indicatorIndex)} data-testid="orion-components-profiles-widgets-file-components-image-slider-div"
			/>
		);
	});

	const styles = {
		sliderContainer: {
			width: "100%",
			marginTop: "10px",
			marginBottom: "20px"
		},
		sliderContent: {
			display: "flex",
			alignItems: "flex-start",
			gap: "4px"
		},
		chevron: {
			display: "flex",
			alignItems: "center",
			flexShrink: 0,
			alignSelf: "center",
			height: "auto"
		},
		chevronIconLeft: {
			color: "#FFF",
			padding: "0px"
		},
		chevronIconRight: {
			color: "#FFF",
			padding: "0px"
		},
		sliderIndicators: {
			display: "flex",
			justifyContent: "center",
		},
		imageWrapper: {
			flex: 1,
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			minWidth: 0
		},
		imageContainer: {
			width: "100%",
			aspectRatio: "16 / 9",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			overflow: "hidden",
			position: "relative"
		},
	};

	return (
		<div style={styles.sliderContainer}>
			<div style={styles.sliderContent}>
				<div style={styles.chevron}>
					<IconButton onClick={handlePrevious} style={styles.chevronIconLeft} data-testid="file-slider-previous-button">
						<ChevronLeftIcon fontSize="large" />
					</IconButton>
				</div>

				<div style={styles.imageWrapper}>
					<div style={{ width: "100%", position: "relative" }}>
						<FileLink
                            key={currentAttachment.fileId} 
                            attachment={currentAttachment}
                            canEdit={canEdit}
                            handleDeleteFile={handleDeleteFile}
                            entityType={entityType}
                            dir={dir}
                            sliderImage={true}
                        />
					</div>
					<div style={styles.sliderIndicators}>{sliderIndicators}</div>
				</div>

				<div style={styles.chevron}>
					<IconButton onClick={handleNext} style={styles.chevronIconRight} data-testid="file-slider-next-button">
						<ChevronRightIcon fontSize="large" />
					</IconButton>
				</div>
			</div>
		</div>
	);
};

export default ImageSlider;
